import React from 'react';
import classNames from 'classnames';

import Store from 'store';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayContext } from 'ui/utils/OverlayManager';
import { getProfilePath } from 'common';
import Data from 'data';
import { removeBreaks } from 'utils/format';

export function copyText(text) {
  const node = document.createElement('input');
  document.body.appendChild(node);
  node.value = text;
  node.select();
  document.execCommand('copy');
  document.body.removeChild(node);
}

export function CopyNotify({ pos, onClose }) {
  const [animating, setAnimating] = React.useState(false);
  React.useEffect(() => setTimeout(() => setAnimating(true), 1), []);
  React.useEffect(() => setTimeout(onClose, 1000), [onClose]);
  return (
    <div className={classNames("lap-notify", {"lap-animating": animating})} style={pos}>
      <FontAwesomeIcon icon={faCopy}/>
    </div>
  );
}

export function useProfileSetId() {
  const storeid = Store.useSelector(store => store.imported && store.importedId);
  const active = Store.useSelector(store => store.embeds.length > 1 ? store.activeEmbed + 1 : null);
  if (storeid) return {id: storeid, set: active};
}

export function CopyBox({ text, ...props }) {
  const overlays = React.useContext(OverlayContext);
  const onClick = React.useCallback(e => {
    copyText(text);
    overlays.async(<CopyNotify pos={{left: e.pageX, top: e.pageY}}/>);
  }, [text, overlays]);

  return (
    <div className="lap-CopyBox" onClick={onClick} {...props}>
      {text}
    </div>
  );
}

export function CopyEmbedBox({ type }) {
  const storeid = Store.useSelector(store => store.imported && store.importedId);
  const active = Store.useSelector(store => store.embeds[store.activeEmbed]?.id);
  if (!storeid) {
    return (
      <div className="lap-CopyBox lap-disabled">Save profile to get embed links.</div>
    );
  }

  const url = new URL(getProfilePath(storeid), window.location);
  url.hash = '#' + encodeURIComponent(active || '') + '&' + type;

  return <CopyBox text={url.href}/>;
}

const tripodText = tripods => Object.entries(tripods).map(([index, level]) => `${String.fromCharCode(96 + parseInt(index))}${level}`).join('');

export function skillLink(skill, pvp) {
  const info = Data.skills[skill.id];
  if (!info) return null;
  const args = [`id=${skill.id}`];
  if (skill.level > 1) args.push(`level=${skill.level}`);
  if (skill.tripods && Object.keys(skill.tripods).length) args.push(`tripods=${tripodText(skill.tripods)}`);
  if (skill.rune) args.push(`rune=${skill.rune}`);
  if (pvp) args.push(`pvp`);
  return `[la-skill ${args.join(' ')}]${removeBreaks(info.name)}[/la-skill]`;
}
